import { type TypographyVariantsOptions } from '@mui/material/styles';

import { colors } from '../colors/colors.js';

export const typography: NonNullable<TypographyVariantsOptions> = {
  fontFamily: 'Inter, sans-serif',
  allVariants: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    color: colors.content.default,
  },
  h1: {
    fontSize: '2rem',
    lineHeight: '120%',
    fontWeight: 700,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontSize: '1.5rem',
    lineHeight: '125%',
    fontWeight: 600,
    letterSpacing: '-0.015em',
  },
  h3: {
    fontSize: '1.25rem',
    lineHeight: '135%',
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontSize: '1.125rem',
    lineHeight: '145%',
    fontWeight: 600,
    letterSpacing: '-0.005em',
  },
  h5: {
    fontSize: '1rem',
    lineHeight: '150%',
    fontWeight: 600,
    letterSpacing: '0.0025em',
  },
  h6: {
    fontSize: '0.875rem',
    lineHeight: '150%',
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  body1: {
    fontSize: '1rem',
    lineHeight: '150%',
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: '150%',
  },
  subtitle1: {
    fontSize: '1rem',
    lineHeight: '150%',
  },
  subtitle2: {
    fontSize: '0.75rem',
    lineHeight: '150%',
    fontWeight: 500,
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: '135%',
  },
  overline: {
    fontSize: '0.625rem',
    lineHeight: '150%',
    textTransform: 'uppercase',
  },
  monospace: {
    fontFamily: 'monospace',
    fontSize: '0.875rem',
    lineHeight: '145%',
  },
  button: {
    textTransform: 'none',
    lineHeight: '145%',
    fontWeight: 600,
  },
};
